// src/services/service.js - FIXED VERSION

import { apiClient } from './api';

export const serviceService = {
  // Get all services
  getAll: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const queryString = queryParams.toString();
      const url = queryString ? `/services?${queryString}` : '/services';
      
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },

  // Get service by ID
  getById: async (id) => {
    try {
      const response = await apiClient.get(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching service by ID:', error);
      throw error;
    }
  },

  // ✅ FIXED: Create service - gunakan FormData langsung dari frontend
  create: async (formDataFromFrontend) => {
    try {
      console.log('=== serviceService.create() ===');
      console.log('Input type:', formDataFromFrontend.constructor.name);
      console.log('Is FormData:', formDataFromFrontend instanceof FormData);
      
      // ✅ PENTING: FormData sudah disiapkan dengan benar dari frontend
      // Jangan mapping ulang, langsung kirim ke backend
      const formData = formDataFromFrontend;
      
      // Debug: log what we're sending
      console.log('FormData contents:');
      for (let pair of formData.entries()) {
        if (pair[0] === 'image') {
          console.log(`  ${pair[0]}: File(${pair[1].size} bytes)`);
        } else {
          console.log(`  ${pair[0]}: ${pair[1]}`);
        }
      }

      // ✅ FIXED: Send FormData langsung dengan proper headers
      const response = await apiClient.post('/services', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('✅ Create response:', response);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error creating service:', error);
      throw error;
    }
  },

  // ✅ FIXED: Update service - gunakan FormData langsung dari frontend
  update: async (id, formDataFromFrontend) => {
    try {
      console.log('=== serviceService.update() ===');
      console.log('Service ID:', id);
      console.log('Input type:', formDataFromFrontend.constructor.name);
      console.log('Is FormData:', formDataFromFrontend instanceof FormData);
      
      // ✅ PENTING: FormData sudah disiapkan dengan benar dari frontend
      const formData = formDataFromFrontend;
      
      // Debug: log what we're sending
      console.log('FormData contents:');
      for (let pair of formData.entries()) {
        if (pair[0] === 'image') {
          console.log(`  ${pair[0]}: File(${pair[1].size} bytes)`);
        } else {
          console.log(`  ${pair[0]}: ${pair[1]}`);
        }
      }

      // ✅ FIXED: Send FormData langsung dengan proper headers
      const response = await apiClient.put(`/services/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('✅ Update response:', response);
      return response.data;
      
    } catch (error) {
      console.error('❌ Error updating service:', error);
      throw error;
    }
  },

  // Delete service
  delete: async (id) => {
    try {
      const response = await apiClient.delete(`/services/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting service:', error);
      throw error;
    }
  },

  // Get services by type
  getByType: async (type) => {
    try {
      const response = await apiClient.get(`/services/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching services by type:', error);
      throw error;
    }
  },

  // Get featured services
  getFeatured: async () => {
    try {
      const response = await apiClient.get('/services/featured');
      return response.data;
    } catch (error) {
      console.error('Error fetching featured services:', error);
      throw error;
    }
  },

  // Toggle featured status
  toggleFeatured: async (id) => {
    try {
      const response = await apiClient.patch(`/services/${id}/featured`);
      return response.data;
    } catch (error) {
      console.error('Error toggling featured status:', error);
      throw error;
    }
  },

  // Search services
  search: async (query) => {
    try {
      const response = await apiClient.get(`/services?search=${encodeURIComponent(query)}`);
      return response.data;
    } catch (error) {
      console.error('Error searching services:', error);
      throw error;
    }
  },

  // Get service types
  getTypes: async () => {
    try {
      const response = await apiClient.get('/services/types');
      return response.data;
    } catch (error) {
      console.error('Error fetching service types:', error);
      throw error;
    }
  }
};

// Named exports untuk backward compatibility
export const serviceAPI = {
  getAll: serviceService.getAll,
  getServices: serviceService.getAll,
  getById: serviceService.getById,
  getServiceById: serviceService.getById,
  create: serviceService.create,
  createService: serviceService.create,
  update: serviceService.update,
  updateService: serviceService.update,
  delete: serviceService.delete,
  deleteService: serviceService.delete,
  getByType: serviceService.getByType,
  getServicesByType: serviceService.getByType,
  getFeatured: serviceService.getFeatured,
  getFeaturedServices: serviceService.getFeatured,
  toggleFeatured: serviceService.toggleFeatured,
  toggleFeaturedStatus: serviceService.toggleFeatured,
  search: serviceService.search,
  searchServices: serviceService.search,
  getTypes: serviceService.getTypes,
  getServiceTypes: serviceService.getTypes
};

// Individual named exports
export const getServices = serviceService.getAll;
export const getServiceById = serviceService.getById;
export const createService = serviceService.create;
export const updateService = serviceService.update;
export const deleteService = serviceService.delete;
export const getServicesByType = serviceService.getByType;
export const getFeaturedServices = serviceService.getFeatured;
export const toggleFeaturedStatus = serviceService.toggleFeatured;
export const searchServices = serviceService.search;
export const getServiceTypes = serviceService.getTypes;

export default serviceService;